module.exports = __webpack_public_path__ + "img/sorting-boxes.5f996c51.svg";